import { render, staticRenderFns } from "./AvailabilityWeekCard.vue?vue&type=template&id=ae039e44"
import script from "./AvailabilityWeekCard.vue?vue&type=script&lang=js"
export * from "./AvailabilityWeekCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ae039e44')) {
      api.createRecord('ae039e44', component.options)
    } else {
      api.reload('ae039e44', component.options)
    }
    module.hot.accept("./AvailabilityWeekCard.vue?vue&type=template&id=ae039e44", function () {
      api.rerender('ae039e44', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sys/teacher/AvailabilityWeekCard.vue"
export default component.exports